import { auth } from '../../../firebase';
import { onAuthStateChanged } from 'firebase/auth';
import axios from 'utils/axios';
import { v4 as uuidv4 } from 'uuid';

const getOrganizationById = (
  orgId,
  { fetchUsers = true, fetchTeams = true } = {},
  callback,
  errCb,
) => {
  return async (dispatch) => {
    dispatch({ type: 'GETTING_ORGANIZATION_BY_ID' });
    try {
      let unsubscribe = onAuthStateChanged(auth, async (user) => {
        const token = await user?.getIdToken();
        const reqId = uuidv4();
        try {
          const response = await axios.get(`/ads/org/${orgId}`, {
            params: {
              'request-id': reqId,
              fetchUsers,
              fetchTeams,
            },
            headers: {
              Authorization: `Bearer ${token}`,
            },
          });
          if (response.status === 200) {
            await dispatch({
              type: 'GETTING_ORGANIZATION_BY_ID_DONE',
            });
            if (typeof callback === 'function') {
              callback(response?.data);
            }
          } else {
            dispatch({
              type: 'GETTING_ORGANIZATION_BY_ID_FAILED',
              payload: `Failed to fetch organization`,
            });
            if (typeof errCb === 'function') {
              errCb(`Failed to fetch organization`);
            }
          }
        } catch (e) {
          dispatch({
            type: 'GETTING_ORGANIZATION_BY_ID_FAILED',
            payload: `Failed to fetch organization`,
          });
          if (typeof errCb === 'function') {
            errCb(e?.response?.data?.message || `Failed to fetch organization`);
          }
        }
        unsubscribe();
      });
    } catch (e) {
      console.log(e);
      dispatch({
        type: 'GETTING_ORGANIZATION_BY_ID_FAILED',
        payload: `Failed to fetch organization`,
      });
      if (typeof errCb === 'function') {
        errCb(`Failed to fetch organization`);
      }
    }
  };
};

export default getOrganizationById;
